<template>
  <section class="hero_wrapper_outer">
    <span class="hero_bg_color"></span>
    <div class="container">
<!--      TODO Add hero slider items from props -->
      <div class="hero_slider_wrapper">
        <VueSlickCarousel v-bind="settings" class="hero_slider" v-if="items">
          <div class="item_hero cursor-pointer" v-for="item in items" :key="'slide-'+item.id" >
            <a :href="item.link" v-if="item.link">
              <img :src="item.img" alt="hero1">
            </a>
            <img :src="item.img" alt="hero1" v-else>
          </div>
          <template #prevArrow="arrowOption">
            <button type="button" class="btn-juliet prev" :data-current="arrowOption.currentSlide"><i class="fa fa-left" aria-hidden="true"> </i></button>
          </template>
          <template #nextArrow="arrowOption">
            <button type="button" class="btn-juliet next" :data-current="arrowOption.currentSlide"><i class="fa fa-right" aria-hidden="true"> </i></button>
          </template>
        </VueSlickCarousel>
        <div class="custom-arrow" ref="hero_slider_arrow"></div>
      </div>
    </div>
  </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

export default {
  name: 'HeroSlider',
  components: { VueSlickCarousel },
  props: {
    items: {
      type: Array,
      default: () => {}
    }
  },
  data () {
    return {
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000
      }
    }
  }
}
</script>

<style scoped>

</style>
